import React, { useState, useEffect } from "react";
import { Grid } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;

const SubscriptionReminder = ({ hasSubscription, subscriptionData }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    if (!hasSubscription || !subscriptionData?.data?.endDate) return;

    const calculateTimeLeft = () => {
      const endDate = new Date(subscriptionData.data.endDate);
      const now = new Date();
      const difference = endDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [hasSubscription, subscriptionData]);

  if (!hasSubscription || !subscriptionData?.data?.endDate) return null;

  const TimeBlock = ({ value, label }) => (
    <div className="time-block">
      <span className="time-value">{String(value).padStart(2, '0')}</span>
      <span className="time-label">{label}</span>
    </div>
  );

  return (
    <div className="subscription-reminder-banner">
      <div className="reminder-info">
        <div className="reminder-icon">
          <CreditCardOutlined />
        </div>
        <div className="reminder-text">
          <span className="reminder-title">Subscription Expiring Soon</span>
          <span className="reminder-subtitle">
            Expires on {new Date(subscriptionData.data.endDate).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </span>
        </div>
      </div>

      <div className="reminder-countdown">
        {timeLeft.days > 0 && <TimeBlock value={timeLeft.days} label="Days" />}
        <TimeBlock value={timeLeft.hours} label="Hrs" />
        <TimeBlock value={timeLeft.minutes} label="Mins" />
        <TimeBlock value={timeLeft.seconds} label="Secs" />
      </div>

      <style jsx>{`
        .subscription-reminder-banner {
          background: #0f172a;
          padding: 12px 20px;
          margin-bottom: 24px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid rgba(16, 185, 129, 0.2);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .reminder-info {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .reminder-icon {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
          padding: 10px;
          border-radius: 8px;
          font-size: 20px;
          display: flex;
        }

        .reminder-text {
          display: flex;
          flex-direction: column;
        }

        .reminder-title {
          color: #10b981;
          font-weight: 600;
          font-size: 15px;
        }

        .reminder-subtitle {
          color: #94a3b8;
          font-size: 13px;
        }

        .reminder-countdown {
          display: flex;
          gap: 8px;
        }

        .time-block {
          background: rgba(16, 185, 129, 0.08);
          border: 1px solid rgba(16, 185, 129, 0.1);
          padding: 6px 10px;
          border-radius: 8px;
          min-width: 52px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .time-value {
          color: #10b981;
          font-weight: 700;
          font-size: 16px;
          line-height: 1;
        }

        .time-label {
          color: #64748b;
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-top: 2px;
        }

        @media (max-width: 768px) {
          .subscription-reminder-banner {
            flex-direction: column;
            gap: 16px;
            align-items: flex-start;
          }
          .reminder-countdown {
            width: 100%;
            justify-content: space-between;
          }
          .time-block {
            flex: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SubscriptionReminder;
